import { Modal } from "reactstrap";
import { STORAGE_URL } from "../../../utils/constants";
import './styles.css';

function FullscreenAd({ad, onClose, isOpen}) {
  return(
    <Modal fullscreen isOpen={isOpen} toggle={onClose}>
      <div style={{position: 'relative', width: '100%', height: '100%'}}>
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            zIndex: 1000,
            background: 'rgba(0,0,0,0.5)',
            color: '#fff',
            border: 'none',
            borderRadius: '50px',
            width: '100px',
            height: '40px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          تخطي
        </button>
        <div className="d-flex justify-content-center align-items-center text-center h-100">
          <a href={ad?.url} target="_blank" rel="noopener noreferrer">
            <img 
              src={STORAGE_URL + ad?.image_url} 
              alt={ad?.title} 
              className="fullscreen-ad-image"
            />
          </a>
        </div>
      </div>
    </Modal>
  );
}

export default FullscreenAd;